import microuniversoApi from "app/api/microuniversoApi";
import { useAppSelector } from "app/redux/hooks";
import { DadosFormularioAutorizado, DefinirAutorizadoSelecionado, FiltroDefinirAutorizado, ListaAutorizado } from "app/types/Autorizado";
import { IOrcamento } from "app/types/IOrcamento";
import { tratamentoErroPadrao } from "app/use-cases";
import { obterPermissao } from "app/use-cases/obterPermissao";
import globalMU from "globalMU";
import React, { useCallback, useEffect, useRef, useState } from "react"
import { Breadcrumb2 } from "../breadcrumb2/Breadcrumb2";
import { Autorizado } from "./Autorizado";
import { AutorizadoPesquisar } from "./autorizado-pesquisar/AutorizadoPesquisar";


export const AutorizadoContainer = () => {
    const orcamento: IOrcamento = useAppSelector((store) => store.orcamento)
    const [listaAutorizado, setListaAutorizado] = useState<ListaAutorizado>({})
    const [dadosFormularioAutorizado, setDadosFormularioAutorizado] = useState<DadosFormularioAutorizado>({})
    const [autorizadoDefinido, setAutorizadoDefinido] = useState<DefinirAutorizadoSelecionado>({})
    const [permitirAlterarAutorizado, setPermitirAlterarAutorizado] = useState<boolean>(false);
    const [permitirIncluirAutorizado, setPermitirIncluirAutorizado] = useState<boolean>(false);
    const [permitirRemoverAutorizado, setPermitirRemoverAutorizado] = useState<boolean>(false);
    const [senhaPreenchida, setsenhaPreenchida] = useState(false);
    const [carregando, setCarregando] = useState(false);

    const isMounted = useRef(true);
    useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);

    const permitidoAcaoFuncionalidade = async (siglaFuncionalidade: string, acao?: string) =>
        await obterPermissao({ funcionalidade: siglaFuncionalidade, acao });

    const atualizarPermissaoIncluirAutorizado = async () => {
        const permitido = await permitidoAcaoFuncionalidade("ORCAMENTO_AUTORIZADO", "INCLUIR");
        if (isMounted.current) {
            setPermitirIncluirAutorizado(permitido);
        }
    };

    const atualizarPermissaoAlterarAutorizado = async () => {
        const permitido = await permitidoAcaoFuncionalidade("ORCAMENTO_AUTORIZADO", "ALTERAR");
        if (isMounted.current) {
            setPermitirAlterarAutorizado(permitido);
        }
    };

    const atualizarPermissaoRemoverAutorizado = async () => {
        const permitido = await permitidoAcaoFuncionalidade("ORCAMENTO_AUTORIZADO", "EXCLUIR");
        if (isMounted.current) {
            setPermitirRemoverAutorizado(permitido);
        }
    };

    const onObterDadosAutorizado = async () => {
        try {
            globalMU.blockUI();
            const resultado = await microuniversoApi.Orcamento.obterDadosAutorizado(orcamento.IdentificadorOrcamento);
            if (isMounted.current) {
                setAutorizadoDefinido(prev => ({ ...prev, Autorizado: resultado }))
                setCarregando(true)
            }
        } catch (e) {
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI();
        }
    }

    const onListarAutorizado = useCallback(async (nome: string, numeroPagina?: number) => {
        try {
            globalMU.blockUI();
            const resultado = await microuniversoApi.Orcamento.listarAutorizado({
                IdentificadorOrcamento: orcamento.IdentificadorOrcamento,
                NumeroPagina: numeroPagina ?? 1,
                TamanhoPagina: 20,
                Nome: nome
            });
            if (isMounted.current) {
                setListaAutorizado(resultado)
            }
        } catch (e) {
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI();
        }
    }, [orcamento.IdentificadorOrcamento])

    const onDefinirAutorizado = useCallback(async (filtroDefinirAutorizado: FiltroDefinirAutorizado) => {
        try {
            globalMU.blockUI();
            const resultado = await microuniversoApi.Orcamento.definirAutorizado({
                IdentificadorOrcamento: orcamento.IdentificadorOrcamento,
                CodigoAutorizado: filtroDefinirAutorizado.CodigoAutorizado,
                Senha: filtroDefinirAutorizado.Senha,
                Observacao: filtroDefinirAutorizado.Observacao
            });
            if (resultado.Autorizado && isMounted.current) {
                setAutorizadoDefinido(resultado)
                globalMU.showSuccessMessage("Autorizado definido com sucesso")
            }
        } catch (e) {
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI();
        }
    }, [orcamento.IdentificadorOrcamento])

    const onLimpar = useCallback(async () => {
        try {
            globalMU.blockUI();
            const resultado = await microuniversoApi.Orcamento.removerAutorizado(orcamento.IdentificadorOrcamento);
            if (resultado && isMounted.current) {
                setAutorizadoDefinido({})
                setListaAutorizado({})
                setDadosFormularioAutorizado({})
                setsenhaPreenchida(false)
            }
        } catch (e) {
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI();
        }
    }, [orcamento.IdentificadorOrcamento])

    const onSenhaModificada = useCallback((senha: string) => {
        setDadosFormularioAutorizado(prev => ({
            ...prev,
            Senha: senha,
            NomeAutorizado: ""
        }))
        setsenhaPreenchida(senha ? true : false)
        if (senha) {
            setListaAutorizado({})
        }
    }, [])

    const onAutorizadoModificado = useCallback((nomeAutorizado: string) => {
        setDadosFormularioAutorizado(prev => ({
            ...prev,
            NomeAutorizado: nomeAutorizado
        }))
    }, [])

    const onObservacaoModificada = useCallback((observacao: string) => {
        setDadosFormularioAutorizado(prev => ({
            ...prev,
            Observacao: observacao
        }))
    }, [])

    useEffect(() => {
        orcamento.IdentificadorOrcamento != null && onObterDadosAutorizado()
        atualizarPermissaoIncluirAutorizado()
        atualizarPermissaoAlterarAutorizado()
        atualizarPermissaoRemoverAutorizado()
    }, [orcamento.IdentificadorOrcamento])

    return (
        <>
            <Breadcrumb2
                exibirBotaoVoltar={false}
                exibirBotaoLimpar={permitirRemoverAutorizado && !orcamento.SomenteLeitura}
                onBotaoLimparClicado={onLimpar}
                passos={["Autorizado"]} />

            {carregando ? autorizadoDefinido?.Autorizado?.Nome ?
                <AutorizadoPesquisar dadosDefinirAutorizado={autorizadoDefinido} /> :
                <Autorizado
                    somenteLeitura={orcamento.SomenteLeitura}
                    senhaPreenchida={senhaPreenchida}
                    dadosAutorizado={dadosFormularioAutorizado}
                    listaAutorizado={listaAutorizado}
                    permitirVisualizarBotaoDefinir={permitirAlterarAutorizado && permitirIncluirAutorizado}
                    onPesquisar={onListarAutorizado}
                    onPesquisarPorPagina={onListarAutorizado}
                    onDefinir={onDefinirAutorizado}
                    onDefinirAutorizado={onDefinirAutorizado}
                    onSenhaModificada={onSenhaModificada}
                    onAutorizadoModificado={onAutorizadoModificado}
                    onObservacaoModificada={onObservacaoModificada}
                /> :
                null
            }
        </>
    )
} 